export default "__VITE_ASSET__DysDjG2R__"